// @flow

import React, { PureComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { i18n, Analytics } from 'shared/utils';
import * as Actions from 'main-app/store/Actions';
import DeleteMachineTypeMutation from 'main-app/mutations/DeleteMachineType';
import Button from 'shared/components/common/Button';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'shared/components/modal';
import type { DeleteMachineTypeModal_machineType as MachineTypeFragment } from './__generated__/DeleteMachineTypeModal_machineType';

type Props = {
  onClose: () => void,
  onSuccess?: () => void,
  machineType: MachineTypeFragment,
};

type State = {
  deleting: boolean,
};

class DeleteMachineTypeModal extends PureComponent<Props, State> {
  state = {
    deleting: false,
  };

  static defaultProps = {
    onSuccess: undefined,
  };

  handleDelete = () => {
    const { machineType, onClose, onSuccess } = this.props;

    this.setState(
      {
        deleting: true,
      },
      async () => {
        try {
          await DeleteMachineTypeMutation.commit({
            variables: {
              input: {
                id: machineType.id,
              },
            },
          });

          onClose();

          if (onSuccess) {
            onSuccess();
          }

          Analytics.trackEvent('Delete Work Center Type', {
            machineTypeName: machineType.name,
          });
          Actions.alertNotification(
            i18n.t(`Work Center Type Successfully Deleted`),
            'success',
          );
        } catch (e) {
          this.setState({ deleting: false });

          Actions.alertNotification(e.message, 'error');
        }
      },
    );
  };

  render() {
    const { deleting } = this.state;
    const { machineType, onClose } = this.props;

    return (
      <Modal maxWidth={700}>
        <ModalHeader
          header={i18n.t('Delete Work Center Type: {{name}}?', {
            name: machineType.name,
          })}
          onClose={onClose}
        />
        <ModalBody withPadding>
          {i18n.t(
            'Deleting this die will remove it from all job tickets that are associated to it.',
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            theme="border-white"
            loading={deleting}
            onClick={this.handleDelete}
          >
            {i18n.t('Yes, Delete Work Center Type')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default createFragmentContainer(DeleteMachineTypeModal, {
  machineType: graphql`
    fragment DeleteMachineTypeModal_machineType on MachineType {
      id
      name
    }
  `,
});
